import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchBrand, deleteBrand } from 'services/brands/duck';
import { push } from 'connected-react-router';
import ViewBrand from 'components/organisms/brand/ViewBrand';
import BrandTabView from 'components/organisms/brand/BrandTabView';

class ViewBrandContainer extends Component {
    componentDidMount() {
        const brandId = this.props.match.params.id;

        if (this.props.fetchBrand && brandId) {
            this.props.fetchBrand({ brandId });
        }
    }

    render() {
        return (
            <BrandTabView selected="view" brand={this.props.brand} push={this.props.push}>
                <ViewBrand
                    brand={this.props.brand}
                    push={this.props.push}
                    deleteBrand={this.props.deleteBrand}>
                    {this.props.children}
                </ViewBrand>
            </BrandTabView>
        );
    }
}

const mapStateToProps = state => ({
    brand: state.brands.brand
});

export default connect(mapStateToProps, { fetchBrand, deleteBrand, push })(ViewBrandContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/brands/ViewBrandContainer.js